import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAuthToken } from "src/utils/AuthUtils";

// Create a single API instance

export const tagTypes = {
  Auth: "Auth",
  Dashboard: "Dashboard",
  User: "User",
  Misc: "Misc",
  Booking: "Booking",
  Vendor: "Vendor",
  Referral: "Referral",
  Notification: "Notification",
  Payment: "Payment",
  Transaction: "Transaction",
  Wallet: "Wallet",
  Setting: "Setting",
  Service: "Service",
  Admin: "Admin",
  Ad: "Ad",
  Occupation: "Occupation",
  Category: "Category",
  Bank: "Bank",
  VariableFee: "VariableFee",
  PartnerCategory: "PartnerCategory",
  lastLogin: "lastLogin",
};
export const api = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl:
      process.env.REACT_APP_ADMIN_BASE_URL || "http://localhost:3000/api",
    timeout: 20000, // ✅ 20 seconds timeout
    prepareHeaders: (headers, { getState }) => {
      const token = getAuthToken();
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
    // Add debugging
    validateStatus: (response, body) => {
      console.log("API Response:", { status: response.status, body });
      return response.status >= 200 && response.status < 300;
    },
  }),
  tagTypes: Object.values(tagTypes),
  endpoints: () => ({}), // Empty endpoints - will be injected by other services
});
